import { LogOut, Moon, Sun } from "lucide-react";
import { useState } from "react";

import { useLogout } from "@/features/auth/useSession";
import type { SessionUser } from "@/lib/api/types";
import { resolve, saveTheme, storedTheme } from "@/lib/theme";

const ITEM =
  "hover:bg-surface-raised rounded-chip flex w-full cursor-pointer items-center gap-2 px-2.5 py-2 text-left text-[13px] disabled:opacity-60";

/**
 * El menú de la tarjeta de usuario: quién sos, el tema y salir.
 *
 * Salir estaba directamente ausente en el sistema anterior: en una inmobiliaria
 * donde varias personas comparten una computadora, eso no es un detalle.
 */
export function UserMenu({ user }: { user: SessionUser }) {
  const salir = useLogout();
  const [dark, setDark] = useState(() => resolve(storedTheme()) === "dark");

  return (
    <div
      role="menu"
      aria-label="Tu cuenta"
      className="bg-surface-muted border-border-overlay rounded-box shadow-popover animate-pop-in text-foreground absolute inset-x-2.5 bottom-16 z-30 border p-1.5"
    >
      <div className="border-border-overlay mb-1 border-b px-2.5 pt-1 pb-2">
        <p className="truncate text-[13px] font-medium">{user.full_name ?? user.username}</p>
        <p className="text-muted-foreground truncate text-xs">{user.username}</p>
      </div>

      <button
        type="button"
        role="menuitem"
        className={ITEM}
        onClick={() => {
          saveTheme(dark ? "light" : "dark");
          setDark(!dark);
        }}
      >
        {dark ? (
          <Sun aria-hidden strokeWidth={1.75} className="size-[15px]" />
        ) : (
          <Moon aria-hidden strokeWidth={1.75} className="size-[15px]" />
        )}
        {dark ? "Usar tema claro" : "Usar tema oscuro"}
      </button>

      <button
        type="button"
        role="menuitem"
        onClick={() => salir.mutate()}
        disabled={salir.isPending}
        className={ITEM}
      >
        <LogOut aria-hidden strokeWidth={1.75} className="size-[15px]" />
        {salir.isPending ? "Cerrando…" : "Cerrar sesión"}
      </button>
    </div>
  );
}
